
import v1 from './v1'

export default {
  '__default': v1,
  '1': v1,
}